import PrivatePageWrapper from '@/components/PrivatePageWrapper/index'

export default {
  name: 'Home',
  components: {
    PrivatePageWrapper
  }
}
